import { Component } from "react";
import { Button, Center, Heading } from "@chakra-ui/react";
import { IBodyshopService } from "../UserService";
import { AiFillCar, AiFillCheckCircle } from "react-icons/ai";
import { FaUserCircle } from "react-icons/fa";
import { MdVerifiedUser } from "react-icons/md";

import moment from "moment";
import LoaderCommon from "../Loader/LoaderCommon";
import { IBSAdonisService } from "../Services/IBSAdonisService";
import { Mixpanel } from "../Services/MixPanel";
import { CommonMethodService } from "../Services/CommonMethodService";
import { UserJob } from "../modals/CurrentUser";
import { AdminChecklistItems } from "../CommonProps";
import { screens } from "../modals/Enums/Screens";
require("./selectJob.css");
const logout = require("./../assets/images/logout.png").default;
const loadingGif = require("./../assets/images/loading.gif").default;
interface Props {
  selectJob: () => void;
  handleDashboardSelectedTab: (dashboardSelectedTab: string) => void;
  ibsService: IBodyshopService;
  logout: () => void;
  navigate: (path: string, options?: { replace?: boolean }) => void;
}
interface State {
  cards: any[];
  selectedJob: any;
  showLoader: boolean;
  btnLoader: boolean;
  userJobs: any;
}

export default class SelectJob extends Component<Props, State> {
  private ibsAdService: IBSAdonisService = new IBSAdonisService();
  private commonMethodService = new CommonMethodService();

  constructor(props: any) {
    super(props);
    this.state = {
      cards: [],
      selectedJob: null,
      showLoader: false,
      btnLoader: false,
      userJobs: this.props?.ibsService?.currentUser?.user?.userJob,
    };
  }

  componentDidMount(): void {
    this.getCard();
  }

  componentDidUpdate() {
    const userJobs = this.state.userJobs;
    const currentUserJob = this.props?.ibsService?.currentUser?.user?.userJob;
    if (
      userJobs &&
      currentUserJob &&
      userJobs.length !== currentUserJob.length
    ) {
      this.getCard();
      this.setState({
        userJobs: this.props?.ibsService?.currentUser?.user?.userJob,
      });
    }
  }

  async getCard() {
    try {
      this.setState({ showLoader: true });
      let cards: any = [];
      const ids: string[] = this.props?.ibsService?.currentUser?.user?.userJob
        ? this.props?.ibsService?.currentUser?.user?.userJob.map(
            (obj: UserJob) => obj.external_id
          )
        : [];

      cards = await this.ibsAdService.getJobEstimateDetailsByIds(ids);
      Mixpanel.track("Get Jobs", {
        cards: cards,
        status: "Data fetched",
      });
      cards = cards.filter((card: any) => !card.isCancelled);
      if (cards.length > 0) {
        cards.map((card: any) => (card.image = loadingGif));

        this.setState({ cards });
        this.setState({ showLoader: false });

        try {
          const ids = cards.map(
            (card: { estimateId: string }) => card.estimateId
          );

          // Ensure `ids` has valid values before making the service call
          if (ids.length !== 0) {
            const responseOfImages: { id: string; image: string }[] =
              (await this.ibsAdService.getUserImageBase64(ids)) as {
                id: string;
                image: string;
              }[];

            cards.forEach((card: any, index: number) => {
              const matchingImage = responseOfImages.find(
                (imagesObj) => imagesObj.id === card.estimateId
              );

              if (matchingImage && matchingImage.image) {
                // Add `image` as a Base64 encoded image URL
                const image = `data:image/png;base64,${matchingImage.image}`;
                cards[index] = { ...card, image };
              } else {
                console.warn(
                  `No image found for estimateId: ${card.estimateId}`
                );
              }
            });
          }
        } catch (error) {
          console.error("Error updating card images:", error);
        } finally {
          this.setState({ cards });
        }
      } else {
        this.setState({ cards: [] });
        this.setState({ showLoader: false });
      }
    } catch (ex: any) {
      if (ex?.status === 401) {
        Mixpanel.track("Get Jobs Error", {
          error: ex,
          status: "Authorization Error",
        });
        this.props.logout();
      } else {
        Mixpanel.track("Get Jobs Error", {
          error: ex,
          status: "Something went wrong",
        });
      }
      console.error(ex);
    }
  }

  selectJoB(job: any) {
    this.setState({
      selectedJob: job,
    });
  }

  async goToJob() {
    this.setState({ btnLoader: true });

    const { navigate } = this.props;
    const recordExist = await this.ibsAdService.fetchInspectionData(
      `${this.state.selectedJob.estimateNumber}`
    );
    if (this.props.ibsService.currentUser) {
      this.props.ibsService.currentUser.user.external_id =
        this.state.selectedJob.estimateNumber;
    }
    this.commonMethodService.setQueryParams(
      this.state.selectedJob.estimateNumber,
      "home"
    );
    this.commonMethodService.setDataIntoStorage(
      "currentUser",
      this.props.ibsService.currentUser
    );
    this.props.ibsService.loggedIn = true;
    this.props.selectJob();
    const selectedJob = this.state.selectedJob;

    const isOnBoardingFlow = selectedJob.adminCheckList.some(
      (checklistItem: string) =>
        checklistItem.includes(AdminChecklistItems.ONBOARDING_FLOW)
    );
    const isBookingFlow = selectedJob.adminCheckList.some(
      (checklistItem: string) =>
        checklistItem.includes(AdminChecklistItems.BOOKING_FLOW)
    );
    Mixpanel.track("Go to Job Clicked", {
      estimateNumber: selectedJob.estimateNumber,
      isOnBoardingFlow,
      isBookingFlow,
      isCancelled: selectedJob.isCancelled,
      timestamp: new Date().toISOString(),
    });
    if (
      isOnBoardingFlow &&
      !isBookingFlow &&
      !this.state.selectedJob.isCancelled
    ) {
      if (recordExist) {
        const id: string = String(this.state.selectedJob.estimateNumber);
        this.commonMethodService.removeSingleQueryParams("formStep");
        this.commonMethodService.setQueryParams(id, screens.bookingInspection);
        const currentParams = CommonMethodService.params();
        navigate(
          `/?estimateid=${currentParams["estimateid"]}&step=${currentParams["step"]}`
        );
        this.props.handleDashboardSelectedTab(screens.bookingInspection);
      } else {
        navigate(`/${this.state.selectedJob.estimateNumber}/welcome`, {
          replace: true,
        });
      }
    }
    this.setState({ btnLoader: false });
  }

  render() {
    return (
      <>
        {this.state.showLoader ? (
          <LoaderCommon isLoginLoader={false} loadingText={""} />
        ) : undefined}
        <Center className="defaultBG">
          <div className="container-select">
            <div className="w-100">
              <div className="headder-select">
                <img
                  src={logout}
                  onClick={() => this.props.logout()}
                  alt="Logout button"
                />
                <div className="mt-2">
                  <Heading color="blue.700">
                    {this.props.ibsService.currentUser?.user?.name}
                  </Heading>
                  <Heading fontSize={"md"} color="blue.400" mb={4} mt={4}>
                    {this.props.ibsService.currentUser?.user?.email}
                  </Heading>
                </div>
              </div>
              <div className="container-card">
                <Heading fontSize={"md"} color="blue.400" mb={2} mt={2}>
                  Select a job
                </Heading>
                <div className="list">
                  {this.state.cards.map((card) => (
                    <div
                      className={
                        card === this.state.selectedJob
                          ? "card card-selected"
                          : "card"
                      }
                      key={card.estimateId}
                      onClick={() => this.selectJoB(card)}
                    >
                      <div className="card-top">
                        <img src={card.image} alt="Card car" />
                        <div className="card-car-info">
                          <div className="card-car-info-top">
                            <p>
                              <AiFillCar className="card-icon" />{" "}
                              {card.vehicleRegistration} {card.vehicleMake}
                            </p>
                            <div>{card.estimateNumber}</div>
                          </div>
                          <div className="card-car-info-bottom">
                            <div>
                              <p>
                                <FaUserCircle className="card-icon" />{" "}
                                {card.ownerName}
                              </p>
                            </div>
                            <div>
                              <p>
                                <MdVerifiedUser className="card-icon" />
                                {card.insurerName
                                  ? card.insurerName
                                  : "No insurer name"}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card-bottom">
                        <div>
                          <div
                            className={
                              card.actualArrival
                                ? "card-bottom-card-full"
                                : "card-bottom-card-outline"
                            }
                          >
                            <AiFillCheckCircle className="card-icon icon-white" />
                            Arrived
                          </div>
                          <h2>
                            {card.actualArrival
                              ? moment(card.actualArrival).format(
                                  "DD MMMM YYYY"
                                )
                              : ""}
                          </h2>
                        </div>
                        <div>
                          <div
                            className={
                              card.actualPickup
                                ? "card-bottom-card-full"
                                : "card-bottom-card-outline"
                            }
                          >
                            <AiFillCheckCircle className="card-icon icon-white" />
                            Est. Collection
                          </div>
                          <h2>
                            {card.expectedPickup
                              ? moment(card.expectedPickup).format(
                                  "DD MMMM YYYY"
                                )
                              : ""}
                          </h2>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div
              className={
                this.state.selectedJob
                  ? "button-select"
                  : "button-select button-disabled"
              }
            >
              <Button
                colorScheme={"blue"}
                variant={"solid"}
                disabled={!this.state.selectedJob}
                onClick={() => this.goToJob()}
              >
                {this.state.btnLoader ? "Loading..." : "Go to job"}
              </Button>
            </div>
          </div>
        </Center>
      </>
    );
  }
}
